<template>
    <div class="container l-activity">


      <div class="absolute-full" style="height:100%;overflow:hidden;border-radius:5px;"  />

      <Carousel style="width:100%;overflow:hidden;height:100%;border-radius:5px;" v-model="carouselIndex" loop :autoplay="items.length > 1" :autoplay-speed="10000" >
        <CarouselItem v-for="item in items" :key="item.id" style="height:100%;" >
          <div style="position:relative;width:100%;height:100%;" >
            <img :src="item.image" @click.stop="handleOpen(item)" style="filter:brightness(0.8);width:100%;height:250px;position:relative;" />
            <div style="position:absolute;left:0px;bottom:10px;right:0;font-size:16px;color:#fff;text-shadow:1px 1px 2px #333;padding:10px;background:#00000033;">
                <div style="">{{item.name}}</div>
                <div style="color:#dda;font-size:12px;">{{ item.created_at }}</div>
            </div>
            </div>
        </CarouselItem>
    </Carousel>
    </div>
  </template>

<script>
export default {
  data() {
    return {
      loading: false,
      carouselIndex: 0,
      items: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData(forced=false) {
      if (forced || this.items.length == 0) {
        this.$api.afterLogin(() => {
          this.loading = true;
          this.$api
              .get(`articles?t=image`)
              .then((res) => {
                const items = res.data.data;
                items.forEach((v)=>{
                  if (v.files) {
                    v.image = JSON.parse(v.files)[0];
                  }
                });
                this.items = items;
              })
              .finally(() => {
                this.loading = false;
              });
        });
      }
    },
    handleOpen(item) {
      if (!item || !item.id) {
        return;
      }
      const url = '/core/articles/' + item.id;
      this.$store.commit('session/push', {
        id: item.id,
        name: item.name,
        icon: 'md-document',
        url,
        base_url: url,
      });
      this.RouteTo(url, false);
    },
  },
};
</script>

  <style lang="less">
  .l-activity{
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    border:2px solid var(--border);
  }

  .l-activity:hover{
    filter:brightness(1.1);

  }

  .l-activity:active{
    position: relative;
    bottom:-1px;
    right:-1px;
  }
  </style>
